
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ConfirmationDialog extends Vue {
    private doIt =false;
  private isOnlyInfo = false;
  private icon = 'fa fa-info';
  private title = 'title';
  private message = 'message';
  private color = 'orange';
  private open = false;
  private confirmationCallback: any | undefined;
  private isConformation = false;

  public showWarning(title: string, message: string): void {
      this.isOnlyInfo = false;
      this.show('fas fa-exclamation-circle', title, message, 'orange');
  }

  public showError(title: string, message: string): void {
      this.isOnlyInfo = false;
      this.show('fa-exclamation-triangle', title, message, 'red');
  }

  public showInfo(title: string, message: string): void {
      this.isOnlyInfo = false;
      this.show('fas fa-info-circle', title, message, 'blue');
  }

  public showConfirmationOnlyInfo(title: string, message: string, confirmationCallback: () => void): void {
      this.showConfirmation(title, message, confirmationCallback);
      this.isOnlyInfo = true;
  }

  public showConfirmation(title: string, message: string, confirmationCallback: () => void): void {
      this.doIt=false;
      this.isConformation = true;
      this.isOnlyInfo = false;
      this.confirmationCallback = confirmationCallback;
      this.show('fas fa-info-circle', title, message, '');
  }

  public show(icon: string, title: string, message: string, color: string): void {
      this.icon = icon;
      this.title = title;
      this.message = message;
      this.color = color;
      this.open = true;
  }

  private close(): void {
      this.$emit('DialogClose');
      this.isConformation = false;
      this.open = false;
  }

  private confirm(): void {
      if (this.confirmationCallback) {
          this.confirmationCallback();
      }
      this.confirmationCallback = undefined;
      this.close();
  }

  private badgeStyle(color: string): string {
      if (color) {
          return `color: ${color} !important;`;
      }
      return '';
  }
}
